import * as React from 'react';
import { InPageDialog } from 'damco-components';
import CostColumnsData from 'views/job-costing/utils/CostColumnsData';
import CostRevTableNew from './CostRevTableNew';
import { IResponseCostorRevenue } from 'reducers/bookings/models';

interface IParams {
    funcId: string;
    finOpsStatus: string[];
    readOnly: boolean,
    isFetchLoading: boolean;
    isRevButtonHidden?: boolean;
    forceFooterUpdate: boolean;
    fetchData: (target: any, page?: number, pageSize?: number, column?: string, order?: number) => void;
    addAction: (data: any, target: string) => void;
    linkAction: (e:any, target: string) => void;
    editAction: (data: any, target: string) => void;
    deleteAction: (data: any, reason: string, target: string) => void;
    isExtraDocumentFeatureEnabled: boolean;
    costResponse: IResponseCostorRevenue;
    revenueResponse: IResponseCostorRevenue;
    cblId: number;
    isNftpBillable: boolean | undefined;
    isNftpRoeEnabled: boolean | undefined;
}
export const CostAndRevenueTablesWrapNew: React.FunctionComponent<IParams> = (props) => {
    const getTable = (propData: IResponseCostorRevenue, name: string, type: string) => {
        return <CostRevTableNew
            id={`${props.funcId}-charges-${name}`}
            isDestination={props.funcId === 'ets' ? true : false}
            readOnly={props.readOnly}
            responseData={propData}
            forceFooterUpdate={props.forceFooterUpdate}
            finOpsStatus={props.finOpsStatus}
            tableTitle={`${name} Table`}
            type={type}
            isLoading={props.isFetchLoading}
            isEditable={false}
            labelAddAction={`Add ${name}`}
            addAction={(e: any) => props.addAction(e, type)}
            editAction={(e: any) => props.editAction(e, type)}
            deleteAction={(e: any, reason: string) => props.deleteAction(e, reason, type)}
            fetchData={props.fetchData}
            linkAction={props.linkAction}
            cblId={props.cblId}
            funcId={props.funcId}
            isRevButtonHidden = {props.isRevButtonHidden}
            isNftpBillable={props.isNftpBillable}
            isNftpRoeEnabled={props.isNftpRoeEnabled}
        />
    }
    return (
        <div className={`${props.readOnly || props.isRevButtonHidden ? 'non-checks' : 'checks'}`}>
            {props.readOnly || props.isRevButtonHidden && <div className="padding-bottom-large"><InPageDialog
                showDialog={props.readOnly || props.isRevButtonHidden}
                type={'info'}
                message={props.isRevButtonHidden ? CostColumnsData.ERROR_MSG.REV : CostColumnsData.ERROR_MSG.GENERIC}
                closeMethod={() => false}
            /></div>}
            {props.revenueResponse && getTable(props.revenueResponse, 'Revenue', CostColumnsData.TYPES.REVENUE)}
            {props.costResponse && getTable(props.costResponse, 'Cost', CostColumnsData.TYPES.COST)}
        </div>
    );
}